import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/autoplay";
import "./Products.css";
import React from 'react';

import image5 from "../../assets/icons/group-1.png";
import img7 from "../../assets/icons/group-2.png";
import img8 from "../../assets/icons/group-4.png";
import img9 from "../../assets/icons/group-3.png";
import { Link } from "react-router-dom";
import useHomeSection from "../../hooks/useHomeSection";
import { useTranslation } from "react-i18next";
import { ArrowLeft } from "lucide-react";

const Achievements = () => {
  const { t } = useTranslation();
  const { data: achievements, error, isLoading } = useHomeSection({ sectionName: 'ivory_Achievements' })

  if (error) {
    return (
      <div className="text-center text-red-400 text-lg">
        {error?.message}
      </div>
    );
  }

  if (isLoading) {
    return (
      <div className="achievements-container">
        <div className="container">
          <div className="achievements-content row w-100">
            {/* Right Side - Text & Stats */}
            <div className="p-2 col-lg-7">
              <div className="w-36 h-4 rounded-md l-load-dt"></div>

              <div className="flex items-center gap-2 my-3">
                <div className="size-6 rounded-md l-load-dt"></div>
                <div className="w-48 h-6 rounded-md l-load-dt"></div>
              </div>

              <div className="flex justify-between items-center gap-3 my-2">
                {
                  [...Array(3)].map((_, i) => (
                    <div key={i} className="grid place-items-center gap-2">
                      <div className="size-24 rounded-md l-load-dt"></div>
                      <div className="w-32 h-5 rounded-md l-load-dt"></div>
                    </div>
                  ))
                }
              </div>
            </div>

            <div className="image-slider col-lg-5">
              <div className="slider-image l-load-dt"></div>
            </div>

          </div>
        </div>
      </div>
    );
  }

  return (
    <>
    <div className="achievements-container">
      <div className="container">
        <Swiper
          modules={[Navigation, Pagination, Autoplay]}
          spaceBetween={20}
          slidesPerView={1}
          navigation
          loop={true}
          // autoplay={{ delay: 3000, disableOnInteraction: false }}
          pagination={{ clickable: true }}
        >
          {achievements?.map((achievement, index) => (
            <SwiperSlide key={index}>
              <div className="achievements-content row w-100 pb-9">
                {/* Right Side - Text & Stats */}
                <div className="text-content col-lg-7">
                  <h2 className="services-header after:w-24 flex justify-center rtl:text-right ltr:text-left">{t('home.achievements-ivory')}</h2>
                  <div className="two-sec d-flex justify-content-between align-items-center">
                    <h2 className="highlighted-text">
                      <img src={image5} alt="icon" className="icon m-2" />
                      {achievement.title}
                    </h2>
                    <Link to={`/achievements/${achievement?.id}`} className=" flex items-center text-secondary-tw">
                      <span>
                        {t('custom.more-details')}
                      </span>
                      <ArrowLeft className="ltr:rotate-180" size={20} />
                    </Link>
                  </div>
                  <div className="stats">
                    <div className="stat-item">
                      <span className="icon"><img src={img7} alt="icon" /></span>
                      <div>
                        <span className="stat-number">{achievement.year}</span><br />
                        <span className="stat-label">{t('achievements.year')}</span>
                      </div>
                    </div>
                    <div className="stat-item">
                      <span className="icon"><img src={img8} alt="icon" /></span>
                      <div>
                        <span className="stat-number">{achievement.number_trainer}</span><br />
                        <span className="stat-label">{t('achievements.trainer')}</span>
                      </div>
                    </div>
                    <div className="stat-item">
                      <span className="icon"><img src={img9} alt="icon" /></span>
                      <div>
                        <span className="stat-number">{achievement.days}</span><br />
                        <span className="stat-label">{t('achievements.train-day')}</span>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Left Side - Image */}
                <div className="image-slider col-lg-5 !h-72">
                  <img src={achievement.image} alt="Achievement" className="slider-image !h-full" />
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
      

      
    </div>
    <Link to="/all-achievements" className="flex items-center justify-center mt-4 bg-secondary-tw text-white px-4 py-2 rounded-md hover:bg-secondary-tw/80 transition-colors  fs-6"
    style={{width:'200px',margin:'0px auto'}} >{t("see-all-achevements")}</Link>
    </>
  );
};

export default Achievements;